<template lang="pug">
section.monitoramento
    resultado-pesquisa(v-if='isFiltering', :resultado='resultadoPesquisa')
    .app-view(:class='{ isNotFiltering: !isFiltering }')
        .row
            .col-12
                informacoes-gerais.dados-area-monitorada(
                    v-if='informacoesGerais',
                    :value='informacoesGerais',
                    :qtdAlertasSocioambientas='monitoramentoAlertaIds.length'
                )

        .d-flex.no-gutters.w-100
            .col-9
                .mapa
                    mapa.map-content(
                        :mapConfig='mapConfig',
                        :mapLayersConfigs='mapLayers',
                        :idMapa='"mapaMonitoramento"',
                        :height='"625px"',
                        :menuMaior='true'
                    )

                    legenda(:values='legenda')

            .col-3
                grupos-alerta.menu-alerta(
                    :gruposAlerta='gruposAlerta',
                    :altura='625'
                )

        .row.mt-3
            .col-12
                .card-tabela
                    FiltrosMonitoramento(@getFiltros='filtrar')

                    .areas-moniotradas-container
                        el-input.m-4.col-6.p-0(
                            clearable,
                            v-model='areasMonitoradasRequest.texto',
                            :placeholder='$t("mensagens.monitoramento.procurePeloNomeOuCpfCnpjOuTerritório")',
                            @change='onChangeSearchInput'
                        )
                            i.el-input__icon.el-icon-search(slot='suffix')

                        el-table(
                            :key="listagemTableKey('monitoramento', areasMonitoradasPaginadas, paginaRequest.page)",
                            :data='areasMonitoradasPaginadas',
                            @sort-change='sortChangeRequest',
                            style='width: 100%'
                        )
                            el-table-column(type='expand')
                                template(slot-scope='props')
                                    el-descriptions.descricao-item-tabela(
                                        :size='"mini"'
                                    )
                                        el-descriptions-item(
                                            :label='$t("mensagens.territorio.areaPlantioEsperada")'
                                        ) {{ formatAreaHa(props.row.areaPlantadaEsperadaHa) }}
                                        el-descriptions-item(
                                            :label='$t("mensagens.territorio.culturaEsperada")'
                                        ) {{ props.row.culturaEsperada != null ? props.row.culturaEsperada.nome : '' }}
                                        el-descriptions-item(
                                            :label='$t("mensagens.territorio.dataPlantioEsperada")'
                                        ) {{ props.row.dataPlantioEsperada ? new Date(props.row.dataPlantioEsperada).toLocaleDateString('pt-BR') : '-' }}

                                        el-descriptions-item(
                                            :label='$t("mensagens.territorio.labels.pessoasProdutores")'
                                        )
                                            .representantes(
                                                v-if='props.row.territorio.representantes && props.row.territorio.representantes.length > 0',
                                                v-for='representante in props.row.territorio.representantes',
                                                :key='representante.id'
                                            )
                                                p {{ representante.nomeRazaoSocial }}
                                                    span ({{ formatCpfCnpj(representante.cpfCnpj) }})&nbsp

                                            p(
                                                v-if='!props.row.territorio.representantes || props.row.territorio.representantes.length === 0'
                                            ) {{ $t('mensagens.territorio.territorioNaoPossuiPessoas') }}
                            .monitoramento
                            el-table-column(
                                :label='$t("mensagens.territorio.labels.nome")',
                                min-width='180',
                                sortable='custom'
                            )
                                .template(slot-scope='scope')
                                    span
                                        | {{ scope.row.territorio ? scope.row.territorio.nome : '-' }}
                                    span.alerta(
                                        v-show='scope.row.alertas.length > 0|| (monitoramentoAlertaIds.includes(scope.row.id) && scope.row.tipoMonitoramento.nome === \'Socioambiental\')'
                                    )
                                        | {{ $t('mensagens.operacao.tabela.alerta') }}
                            el-table-column(
                                :label='$t("mensagens.comuns.tipo")',
                                min-width='140'
                            )
                                .template(slot-scope='scope')
                                    div
                                        | {{ scope.row.tipoMonitoramento ? scope.row.tipoMonitoramento.nome : '-' }}
                            el-table-column(
                                :label='$t("mensagens.territorio.labels.situacaoColheita")',
                                min-width='110'
                            )
                                .template(slot-scope='scope')
                                    p(
                                        v-if='scope.row.tipoMonitoramento.nome !== "Socioambiental"'
                                    )
                                        span {{ updateStatusColheita(scope.row.statusColheita) }}
                                    p(v-else)
                                        span -

                            el-table-column(
                                :label='$t("mensagens.comuns.pessoa")',
                                min-width='200'
                            )
                                .template(slot-scope='scope')
                                    p(
                                        v-if='scope.row.territorio.representantes && scope.row.territorio.representantes.length > 0'
                                    ) {{ scope.row.territorio.representantes[0].nomeRazaoSocial }}
                                        span ({{ formatCpfCnpj(scope.row.territorio.representantes[0].cpfCnpj) }})
                                        el-tag.ml-2(
                                            v-if='scope.row.territorio.representantes.length > 1',
                                            size='mini'
                                        )
                                            | {{ scope.row.territorio.representantes.length - 1 }}
                                    p(v-else) -

                            el-table-column(
                                :label='$t("mensagens.operacao.status")',
                                min-width='100'
                            )
                                .template(slot-scope='scope')
                                    span {{ scope.row.statusVegaApi === 'ATIVO' ? 'Ativo' : 'Cancelado' }}

                            el-table-column(
                                :label='$t("mensagens.territorio.comercializacao.safra")',
                                min-width='100'
                            )
                                .template(slot-scope='scope')
                                    p(
                                        v-if='scope.row.tipoMonitoramento.nome !== "Socioambiental"'
                                    )
                                        span {{ scope.row.safra.descricao }}
                                    p(v-else)
                                        span -

                            el-table-column(
                                min-width='70',
                                align='center',
                                :label='$t("mensagens.comuns.acoes")'
                            )
                                .template(slot-scope='scope')
                                    el-dropdown.action-button(trigger='click')
                                        span.el-dropdown-link
                                            i.mdi.mdi-dots-vertical

                                        el-dropdown-menu(
                                            v-if='scope.row.tipoMonitoramento.nome == "Socioambiental"',
                                            slot='dropdown'
                                        )
                                            el-tooltip(
                                                v-if='scope.row.statusVegaApi === "CANCELADO"',
                                                :content='$t("mensagens.monitoramentoSocioambiental.visualizaçãoNaoDisponivel")',
                                                placement='top'
                                            )
                                                el-dropdown-item.disabled(
                                                    icon='el-icon-view'
                                                ) {{ $t('mensagens.comuns.visualizar') }}
                                            el-dropdown-item(
                                                v-else,
                                                icon='el-icon-view',
                                                @click.native='goToAreaMonitorada(scope.row)'
                                            ) {{ $t('mensagens.comuns.visualizar') }}

                                            div(
                                                v-if='usuarioLogado.monitoramentoAccess && usuarioLogado.monitoramentoEnviar'
                                            )
                                                el-dropdown-item(
                                                    v-if='scope.row.statusVegaApi === "ATIVO"',
                                                    icon='el-icon-remove',
                                                    @click.native='abrirModalCancelarMonitoramento(scope.row)'
                                                ) {{ $t('mensagens.comuns.cancelar') }}

                                                el-dropdown-item(
                                                    v-else,
                                                    icon='el-icon-refresh-left',
                                                    @click.native='abrirModalReativarMonitoramento(scope.row)'
                                                ) {{ $t('mensagens.monitoramentoSocioambiental.reativarMonitoramento') }}

                                        el-dropdown-menu(
                                            v-else,
                                            slot='dropdown'
                                        )
                                            el-dropdown-item(
                                                icon='el-icon-view',
                                                @click.native='goToAreaMonitorada(scope.row)'
                                            ) {{ $t('mensagens.comuns.visualizar') }}
                                            el-dropdown-item(
                                                v-if='scope.row.statusVegaApi === "ATIVO"',
                                                icon='el-icon-edit',
                                                @click.native='updateAreaMonitorada(scope.row)'
                                            ) {{ $t('mensagens.comuns.editar') }}

                                            el-dropdown-item(
                                                v-show='scope.row.statusVegaApi === \'ATIVO\'',
                                                icon='el-icon-circle-plus-outline',
                                                @click.native='adicionarNovoCiclo(scope.row)'
                                            ) {{ $t('mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.adicionarNovoCiclo') }}

                                            el-dropdown-item(
                                                v-if='scope.row.statusVegaApi === "ATIVO"',
                                                icon='el-icon-remove',
                                                @click.native='abrirModalCancelarMonitoramento(scope.row)'
                                            ) {{ $t('mensagens.comuns.cancelar') }}

                                            el-dropdown-item(
                                                v-else,
                                                icon='el-icon-refresh-left',
                                                @click.native='abrirModalReativarMonitoramento(scope.row)'
                                            ) {{ $t('mensagens.monitoramentoSocioambiental.reativarMonitoramento') }}

                            template(slot='empty')
                                el-empty(
                                    :description='$t("mensagens.monitoramentoAgricola.voceAindaNaoPossuiNenhumaAreaEmMonitoramento")'
                                )

                        .py-3(style='text-align: center')
                            el-pagination(
                                background,
                                :page-size='paginaRequest.size',
                                :current-page.sync='paginaRequest.page',
                                layout='prev, pager, next',
                                :total='totalAreasMonitoradas',
                                @current-change='atualizarPagina'
                            )

    SendOrEditMonitoramento(
        v-if='showMonitoramentoModal',
        :selectedTerritorioNome='territorioParaMonitoramento.nome',
        :selectedTerritorio='territorioParaMonitoramento',
        :actionType='acao',
        @atualizado='updateRequests()'
    )

    #modal-cancelar-monitoramento
        el-dialog(
            :visible.sync='mostrarModalCancelarMonitoramento',
            width='500px',
            :before-close='fecharModalCancelarMonitoramento'
        )
            span(slot='title')
                h1.font-weight-bold Cancelar Monitoramento
                h2 {{ territorioSelecionado.nome }}
            p {{ $t('mensagens.monitoramentoAgricola.temCertezaQueDesejaCancelarOMonitoramentoDesteTerritorio') }}
            .buttons
                el-button(
                    size='mini',
                    @click='fecharModalCancelarMonitoramento'
                )
                    | Voltar
                el-button(
                    type='primary',
                    size='mini',
                    @click='cancelarMonitoramento'
                )
                    | {{ $t('mensagens.monitoramentoAgricola.cancelarMonitoramento') }}

    #modal-reativar-monitoramento
        el-dialog(
            :visible.sync='mostrarModalReativarMonitoramento',
            width='500px',
            :before-close='fecharModalReativarMonitoramento'
        )
            span(slot='title')
                h1.font-weight-bold Reativar Monitoramento
                h2 {{ territorioSelecionado.nome }}
            p {{ $t('mensagens.monitoramentoAgricola.temCertezaQueDesejaReativarOMonitoramentoDesteTerritorio') }}
            .buttons
                el-button(
                    size='mini',
                    @click='fecharModalReativarMonitoramento'
                )
                    | Voltar
                el-button(
                    type='primary',
                    size='mini',
                    @click='reativarMonitoramento'
                )
                    | {{ $t('mensagens.monitoramentoAgricola.reativarMonitoramento') }}
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

import GruposAlerta from '@/components/GruposAlerta';
import ResultadoPesquisa from '@/components/ResultadoPesquisa';
import InformacoesGerais from '@/components/quantitativos/InformacoesGerais';
import InformacoesMonitoramento from '@/components/quantitativos/InformacoesMonitoramento';
import Legenda from '@/components/Legenda';
import Mapa from '@/components/MapaLeaflet';
import FiltrosMonitoramento from '@/components/FiltrosMonitoramento';

import UtilsService from '@/services/UtilsService';
import clienteService from '@/services/ClienteService';
import AreasMonitoradasService from '@/services/AreasMonitoradasService';
import { LEGENDA_MAPA_INICIAL } from '@/utils/layouts/legendas';
import formatters from '@/utils/formatters';
import SendOrEditMonitoramento from '@/components/areamonitorada/SendOrEditMonitoramento';

import MonitoramentoService from '@/services/MonitoramentoService';
import AlertaService from '@/services/AlertaService';

export default {
    name: 'index',

    data() {
        return {
            areasMonitoradasPaginadas: [],
            totalAreasMonitoradas: 0,
            informacoesGerais: null,
            resultadoPesquisa: [],
            areasMonitoradas: [],
            gruposAlerta: [],
            mapLayers: null,
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    ferramentasControl: false
                },
                dontZoomIn: true,
                addLimitesEstado: true
            },
            legenda: LEGENDA_MAPA_INICIAL,
            searchText: null,
            acao: 'edit',
            territorioParaMonitoramento: {},
            mostrarModalCancelarMonitoramento: false,
            mostrarModalReativarMonitoramento: false,
            territorioSelecionado: {},
            idAreaMonitoradaSelecionada: null,
            tipoMonitoramentoSelecionado: '',
            cancelarTipoMonitoramento: [],
            tipoMonitoramento: {
                Agrícola: 'AGRICOLA',
                Socioambiental: 'SOCIOAMBIENTAL',
                'Agrícola,Socioambiental': 'AGRICOLA_E_SOCIOAMBIENTAL',
                'Socioambiental,Agrícola': 'AGRICOLA_E_SOCIOAMBIENTAL'
            },
            monitoramentoAlertaIds: [],
            areasMonitoradasRequest: {
                texto: ''
            },
            paginaRequest: {
                page: 1,
                size: 20,
                sort: 'data_cadastro,DESC'
            }
        };
    },

    components: {
        Legenda,
        GruposAlerta,
        ResultadoPesquisa,
        InformacoesGerais,
        InformacoesMonitoramento,
        Mapa,
        SendOrEditMonitoramento,
        FiltrosMonitoramento
    },

    computed: {
        ...mapGetters([
            'filtro',
            'culturaSelecionada',
            'isFiltering',
            'showMonitoramentoModal'
        ]),

        ...mapState(['usuarioLogado'])
    },

    created() {
        this.updateRequests();
    },

    methods: {
        ...mapActions(['changeShowMonitoramentoModal']),
        findDadosQuantitativos() {
            AreasMonitoradasService.getQuantitativos(this.filtro).then(
                result => {
                    if (result.status === 200) {
                        this.informacoesGerais = result.data;
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.monitoramentoAgricola.ocorreuUmErroAoBuscarOsQuantitativosDeAreas'
                            )
                        });
                    }
                }
            );
        },
        findAlertas() {
            UtilsService.findAlertas(this.filtro)
                .then(result => {
                    this.gruposAlerta = result.data.filter(item => {
                        if (item.id !== 4) return item;
                    });

                    AlertaService.findAreaMonitoradaWithAlerta().then(
                        ({ data }) => {
                            Object.keys(this.gruposAlerta).forEach(item => {
                                /* if (this.gruposAlerta[item].nome === 'Monitoramento da fase de plantio') {
									this.gruposAlerta[item].nome = 'Alertas de monitoramento da fase de plantio';
								} */
                                if (
                                    this.gruposAlerta[item].nome ===
                                    'Monitoramento da produtividade'
                                ) {
                                    this.gruposAlerta[item].nome =
                                        'Alertas de monitoramento da produtividade';
                                }
                                if (
                                    this.gruposAlerta[item].nome ===
                                    'Monitoramento de Colheita'
                                ) {
                                    this.gruposAlerta[item].nome =
                                        'Alertas de monitoramento de colheita';
                                }
                                if (
                                    this.gruposAlerta[item].nome ===
                                    'Alertas socioambientais'
                                ) {
                                    this.gruposAlerta[item].alertas = data;
                                }
                            });

                            this.monitoramentoAlertaIds = [];
                            data.forEach(({ id }) => {
                                this.monitoramentoAlertaIds.push(id);
                            });
                        }
                    );
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.home.centralAlertas.ocorreuUmErroAoBuscarOsAlertas'
                        )
                    });
                });
        },
        updateStatusColheita(colheita) {
            if (colheita === 'COLHIDO') {
                return 'Colhido';
            } else {
                if (colheita === 'NAO_COLHIDO' || !colheita) {
                    return this.$t(
                        'mensagens.monitoramentoAgricola.naoColhido'
                    );
                } else {
                    return this.$t(
                        'mensagens.monitoramentoAgricola.emColheita'
                    );
                }
            }
        },
        atualizarPagina() {
            this.findAreasMonitoradasPaginado();
            this.findAreasMonitoradasMapa();
        },

        findResultadoPesquisa() {
            clienteService.findByFiltro(this.filtro).then(result => {
                this.resultadoPesquisa = result.data;
            });
        },

        findAreasMonitoradasMapa() {
            AreasMonitoradasService.findByFiltro(this.filtro).then(result => {
                if (result.status === 200) {
                    this.areasMonitoradas = result.data;
                    this.configureLayersMapa();
                } else {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.monitoramentoAgricola.ocorreuUmErroAoBuscarOsDadosDasAreasMonitoradas'
                        )
                    });
                }
            });
        },

        findAreasMonitoradasPaginado() {
            this.limparTextoBusca();
            if (
                this.areasMonitoradasRequest.texto.length === 0 ||
                this.areasMonitoradasRequest.texto.length > 2
            ) {
                AreasMonitoradasService.findByFiltroPaginado(
                    this.areasMonitoradasRequest,
                    this.paginaRequest
                )
                    .then(({ data }) => {
                        this.areasMonitoradasPaginadas = data.resultados;
                        this.totalAreasMonitoradas = data.totalResultados;
                        if (!this.areasMonitoradasRequest.texto) {
                            this.areasMonitoradasRequest = { texto: '' };
                        }
                    })
                    .catch(() => {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.monitoramentoAgricola.ocorreuUmErroAoBuscarOsDadosDasAreasMonitoradas'
                            )
                        });
                    });
            } else {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.comuns.digiteNoMinimo3CaracteresParaPesquisar'
                    )
                });
            }
        },

        updateRequests() {
            this.findDadosQuantitativos();

            this.findAlertas();

            this.findAreasMonitoradasMapa();

            this.findAreasMonitoradasPaginado();

            if (this.isFiltering) {
                this.findResultadoPesquisa();
            }
        },
        configureLayersMapa() {
            this.mapLayers = [];

            _.each(this.areasMonitoradas, areaMonitorada => {
                this.mapLayers.push({
                    name: 'centroid' + areaMonitorada.id,
                    geoJson: areaMonitorada.centroide,
                    tipoCultura:
                        areaMonitorada.culturaEsperada === null
                            ? null
                            : areaMonitorada.culturaEsperada.codigo,
                    popup: this.getPopupAreaMonitorada(areaMonitorada),
                    tooltip: this.getTooltipAreaMonitorada(areaMonitorada)
                });
            });
        },

        getPopupAreaMonitorada(areaMonitorada) {
            return areaMonitorada
                ? `<h5><b>${this.$t(
                      'mensagens.monitoramento.historico.agricola.areaMonitorada'
                  )} ${areaMonitorada.territorio.nome}</b></h5>
					<br>
					<h6>${this.$t('mensagens.monitoramentoSocioambiental.tipoMonitoramento')}: ${
                      areaMonitorada.tipoMonitoramento.nome
                  }</h6>
					<br/>
					<div>
						<b>Cultura: </b>
						${
                            areaMonitorada.culturaEsperada != null
                                ? areaMonitorada.culturaEsperada.nome
                                : this.$t('mensagens.cultura.NAO_IDENTIFICADA')
                        }
					</div>
					<br>
					<a id='detalhesAreaMonitorada' style='color: #01A3A4; cursor: pointer; text-decoration: underline' onClick="window.location.replace('#/area-monitorada/${
                        areaMonitorada.id
                    }', '_blank'); window.location.reload()">${this.$t(
                      'mensagens.comuns.maisDetalhes'
                  )}</a>
					<br>`
                : '';
        },

        getTooltipAreaMonitorada(areaMonitorada) {
            if (!areaMonitorada) return null;

            let tooltip = `${this.$t(
                'mensagens.monitoramento.historico.agricola.areaMonitorada'
            )}: ${areaMonitorada.territorio.nome} <br /> <ul>`;

            if (
                areaMonitorada.tipoMonitoramento.codigo === 'SOCIOAMBIENTAL' ||
                areaMonitorada.tipoMonitoramento.codigo ===
                    'AGRICOLA_E_SOCIOAMBIENTAL'
            ) {
                tooltip += `<li>${this.$t(
                    'mensagens.monitoramentoSocioambiental.titulo'
                )}</li>`;
            }

            if (
                areaMonitorada.tipoMonitoramento.codigo === 'AGRICOLA' ||
                areaMonitorada.tipoMonitoramento.codigo ===
                    'AGRICOLA_E_SOCIOAMBIENTAL'
            ) {
                tooltip += `<li>${this.$t(
                    'mensagens.monitoramentoAgricola.baseHeader.titulo'
                )}</li>`;
            }

            if (areaMonitorada.culturaEsperada) {
                tooltip += `<li>${this.$t(
                    'mensagens.monitoramentoAgricola.tabelaMonitoramentoAgricola.culturaEsperada'
                )}: ${areaMonitorada.culturaEsperada.nome}</li>`;
            }

            return tooltip + '</ul>';
        },

        onChangeSearchInput() {
            this.paginaRequest.page = 1;
            this.findAreasMonitoradasPaginado();
        },

        goToAreaMonitorada(areaMonitorada) {
            this.$router.push({
                name: 'AreaMonitorada',
                params: { idAreaMonitorada: areaMonitorada.id }
            });
        },

        setDados(row) {
            this.territorioParaMonitoramento.id = row.id;
            this.territorioParaMonitoramento.nome = row.territorio.nome;
            this.territorioParaMonitoramento.idTerritorio = row.territorio.id;
            this.territorioParaMonitoramento.tipoMonitoramento =
                row.tipoMonitoramento;
            if (row.tipoMonitoramento.codigo !== 'SOCIOAMBIENTAL') {
                this.territorioParaMonitoramento.idSafra = row.safra.id;
                this.territorioParaMonitoramento.cultura = row.culturaEsperada;
                this.territorioParaMonitoramento.dataPlantio =
                    row.dataPlantioEsperada;
                this.territorioParaMonitoramento.areaDoPlantio =
                    row.areaPlantadaEsperadaHa;
                this.territorioParaMonitoramento.produtividade =
                    row.produtividadeEsperadaScHa;
            } else {
                this.territorioParaMonitoramento.idSafra = '';
                this.territorioParaMonitoramento.cultura = '';
                this.territorioParaMonitoramento.dataPlantio = '';
                this.territorioParaMonitoramento.areaDoPlantio = '';
                this.territorioParaMonitoramento.produtividade = '';
            }
        },

        adicionarNovoCiclo(row) {
            this.acao = 'addCiclo';
            this.setDados(row);
            this.changeShowMonitoramentoModal();
        },

        formatCpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatTocpfCnpj(cpfCnpj);
        },

        formatAreaHa(areaHa) {
            return formatters.formatNumber(areaHa, 2);
        },

        updateAreaMonitorada(row) {
            this.acao = 'edit';
            this.setDados(row);
            this.changeShowMonitoramentoModal();
        },

        handleCloseModalSendToMonitoramento() {
            this.changeShowMonitoramentoModal();
            this.clearAll();
        },

        clearAll() {
            this.clearSendToMonitoramento();
        },

        clearSendToMonitoramento() {
            this.territorioParaMonitoramento = {};
        },

        abrirModalCancelarMonitoramento({ id, territorio }) {
            this.idAreaMonitoradaSelecionada = id;
            this.territorioSelecionado = territorio;
            this.mostrarModalCancelarMonitoramento = true;
        },

        fecharModalCancelarMonitoramento() {
            this.mostrarModalCancelarMonitoramento = false;
        },

        cancelarMonitoramento() {
            MonitoramentoService.cancelarMonitoramento(
                this.idAreaMonitoradaSelecionada
            )
                .then(() => {
                    const monitoramento =
                        this.cancelarTipoMonitoramento.length === 2
                            ? ''
                            : this.cancelarTipoMonitoramento.toString();
                    this.$notify.success({
                        message: this.$tc(
                            'mensagens.monitoramentoAgricola.monitoramentoCanceladoComSucesso',
                            1,
                            { monitoramento }
                        )
                    });
                    this.fecharModalCancelarMonitoramento();
                    this.updateRequests();
                    this.atualizarPagina();
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.monitoramentoAgricola.naoFoiPossivelCancelarOMonitoramento'
                        )
                    });
                });
        },

        sortChangeRequest({ column, order }) {
            const ordem = order === 'ascending' ? 'ASC' : 'DESC';
            const campoOrdenacao =
                column.label === 'Nome' ? 'nome' : 'data_cadastro';
            this.paginaRequest.sort = `${campoOrdenacao},${ordem}`;

            this.findAreasMonitoradasPaginado();
        },

        limparTextoBusca() {
            if (this.areasMonitoradasRequest.texto) {
                const cpfCnpj = formatters.cpfCnpjFormatToNumeral(
                    this.areasMonitoradasRequest.texto
                );
                this.areasMonitoradasRequest.texto =
                    cpfCnpj === ''
                        ? this.areasMonitoradasRequest.texto
                        : cpfCnpj;
            } else {
                this.areasMonitoradasRequest.texto = '';
            }
        },

        filtrar(filtro) {
            this.areasMonitoradasRequest = filtro;
            this.findAreasMonitoradasPaginado();
        },

        abrirModalReativarMonitoramento({ id, territorio }) {
            this.idAreaMonitoradaSelecionada = id;
            this.territorioSelecionado = territorio;
            this.mostrarModalReativarMonitoramento = true;
        },

        fecharModalReativarMonitoramento() {
            this.mostrarModalReativarMonitoramento = false;
        },

        reativarMonitoramento() {
            MonitoramentoService.reativarMonitoramento(
                this.idAreaMonitoradaSelecionada
            )
                .then(() => {
                    this.updateRequests();
                    this.fecharModalReativarMonitoramento();
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.monitoramentoAgricola.monitoramentoReativadoComSucesso'
                        )
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.monitoramentoAgricola.naoFoiPossivelReativarOMonitoramento'
                        )
                    });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.monitoramento {
    width: 100%;
    height: calc(100vh - 65px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 20px;

    .alerta {
        font-size: 12px;
        color: #616266;
        background-color: #f7d7da;
        border-color: #f5c6cb;
        border-radius: 4px;
        margin-left: 8px;
        padding: 0 4px;
        font-style: italic;
    }

    .areas-moniotradas-container {
        width: 100%;
        background-color: var(--white);
        border-radius: 4px;
    }

    .el-table {
        .cell {
            word-break: break-word !important;
        }

        .action-button {
            cursor: pointer;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }
    }

    .card-tabela {
        background-color: var(--white);
        border-radius: 4px;
        overflow: hidden;
    }
}

.menu-alerta {
    border-radius: 0 4px 4px 0;
}

.dados-area-monitorada {
    margin-bottom: 15px;
}

.mapa {
    position: relative;
    z-index: 1;
    border-radius: 5px 0 0 5px !important;
    overflow: hidden;
}

.disabled,
.disabled:hover {
    color: #ccc;
}

#modal-cancelar-monitoramento,
#modal-reativar-monitoramento {
    p {
        margin-top: -15px;
    }

    .buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        margin-bottom: -10px;
    }
}
</style>
